import Clickable from '@carvana/merch-components/Clickable';
import { CarvanaTheme } from '@carvana/theme';
import styled from 'styled-components';

export const ZipCodeSearchArea = styled.div`
  width: 100%;

  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    width: 100%;
    padding-top: 0px;
  }
`;

export const ZipCodeSearchInnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
`;

export const ZipCodeSearchTextbox = styled.input`
  height: 56px;
  border-radius: 3px;
  flex: 5;
  max-width: 100%;
  width: 100%;
  font-size: 24px;
  text-align: center;
  padding-top: 1em;
  font-weight: bold;
  text-align: left;
  padding-left: 1em;
  color: #183558;

  @media (min-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    max-width: unset;
  }
  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    max-width: unset;
  }
`;

export const ZipCodeSearchAreaButton = styled(Clickable)`
  background-color: ${CarvanaTheme.carvana.blue.primary};
  color: white;
  height: 56px;
  cursor: pointer;

  font-family: Brandon Text;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 25px;

  border-radius: 3px;
  padding: 1em;
  flex: 1;
  max-width: 10em;
  margin: 0px;
  line-height: 2em;

  @media (min-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    max-width: unset;
  }
  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    max-width: unset;
  }
`;

export const ZipCodeMessage = styled.div`
  color: white;
  float: left;
  padding-left: 9px;
`;
